<script setup lang="ts">
const isInit = ref(false)
const isLoading = ref(false)
const isError = ref(false)
const searchStore = useSearchStore()

onMounted(async () => {
  try {
    await handleOnFetchHashtags(true)
  } finally {
    isInit.value = true
  }
})

watch(
  () => searchStore.keyword,
  () => {
    handleOnFetchHashtags(true)
  }
)

/**
 * 해시태그 목록 조회
 */
const handleOnFetchHashtags = async (refresh = false) => {
  try {
    isLoading.value = true
    isError.value = false
    await searchStore.fetchSearchHashtags(
      {
        ...searchStore.hashtags.payload,
        query: searchStore.keyword,
      },
      refresh
    )
  } catch {
    isError.value = true
  } finally {
    isLoading.value = true
  }
}
</script>

<template>
  <div class="search-result-hashtag">
    <NovaRecyclerGrid
      v-if="isInit && searchStore.hashtags.items.length"
      :items="searchStore.hashtags.items"
      :is-last="searchStore.hashtags.last"
      :is-loading="isLoading"
      :is-error="isError"
      :is-refresh="searchStore.hashtags.refresh"
      :key-name="'hashtagSn'"
      :page-mode="true"
      :error-message="$t('statusMessages.network.error')"
      :responsive="{
        mobile: {
          columns: 1,
          rowGap: 12,
          columnGap: 0,
          padding: { top: 0, right: 10, bottom: 20, left: 10 },
        },
        tablet: { columns: 1, rowGap: 12, columnGap: 0 },
        desktop: { columns: 1, rowGap: 12, columnGap: 0 },
      }"
      @load-more="handleOnFetchHashtags"
    >
      <template #item="{ item }">
        <NovaSearchResultItemHashtag :source="item" />
      </template>
    </NovaRecyclerGrid>

    <NovaBoxEmptyMessage
      v-if="isInit && !searchStore.hashtags.items.length"
      :message="
        $t('statusMessages.search.empty', { keyword: searchStore.keyword })
      "
      :fill="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.search-result-hashtag {
  flex-grow: 1;
  height: 100%;
}
</style>
